import { FC, useState } from 'react'
import { Button, Form, Modal, notification } from 'antd'
import Task from '../../../types/api/task'
import { useForm } from 'antd/es/form/Form'
import { UploadFile as UploadFileInterface } from 'antd/es/upload'
import UploadFile from '../../../components/form-items/upload-file/upload-file'
import useUploadFiles from '../../../hooks/api/use-upload-file'
import { useUpdateTaskMutation } from '../../../store/api/tasks-api'
import { StrapiUpdate } from '../../../types/strapi/strapi'
import { useUpdateShipmentMutation } from '../../../store/api/shipments-api'
import useErrorModal from '../../../hooks/api/use-error-modal'

interface CompleteHonestSignProps {
    task: Task
}

const CompleteHonestSign: FC<CompleteHonestSignProps> = ({ task }) => {
    const [open, setOpen] = useState<boolean>(false)
    const [form] = useForm()
    const [updateShipment, updateShipmentState] = useUpdateShipmentMutation()
    const [uploadFiles, uploadState] = useUploadFiles()
    const [updateTask, updateTaskState] = useUpdateTaskMutation()

    useErrorModal(updateShipmentState, 'Не удалось обновить отгрузку')
    useErrorModal(updateTaskState, 'Не удалось обновить задачу')

    const onClick = () => {
        setOpen(true)
    }

    const getUpdateTaskQueryArg = (): StrapiUpdate<Task> => ({
        docId: task.documentId,
        body: { data: { taskStatus: 'Завершена' } },
    })

    const onOk = async () => {
        try {
            await form.validateFields()

            const shipmentDocId = task.shipment?.documentId
            if (!shipmentDocId) {
                notification.error({ message: 'У задачи нет связанной отгрузки' })
                return
            }

            const files: UploadFileInterface[] = form.getFieldValue('files') ?? []
            const result = await uploadFiles(files)

            if (!result.data?.length) {
                notification.error({ message: 'Не удалось сохранить файл' })
                return
            }

            await updateShipment({
                docId: shipmentDocId,
                body: {
                    data: {
                        //@ts-ignore Strapi media multiple: массив numeric id
                        honestSignsCodesFile: result.data.map(f => f.id),
                    },
                },
            }).unwrap()

            await updateTask(getUpdateTaskQueryArg()).unwrap()
            notification.success({ message: 'Задача закрыта' })
            setOpen(false)
            form.resetFields()
        } catch (e) {
            if (e && typeof e === 'object' && 'errorFields' in e) {
                return
            }
            console.error(e)
            notification.error({ message: 'Не удалось завершить задачу' })
        }
    }

    return (
        <>
            <Button type={'primary'} onClick={onClick} disabled={task.taskStatus === 'Завершена'}>
                Завершить
            </Button>

            <Modal
                title={'Задача «Честный знак»'}
                open={open}
                okText={'Завершить задачу'}
                onOk={onOk}
                okButtonProps={{
                    loading:
                        uploadState.isLoading ||
                        updateShipmentState.isLoading ||
                        updateTaskState.isLoading,
                }}
                onCancel={() => {
                    setOpen(false)
                    form.resetFields()
                }}
                destroyOnClose
                cancelButtonProps={{ danger: true }}
            >
                <Form form={form} layout={'vertical'}>
                    <UploadFile
                        name={'files'}
                        label={'База кодов'}
                        multiple
                        rules={[{ required: true, message: 'Прикрепите файл «База кодов»' }]}
                    />
                </Form>
            </Modal>
        </>
    )
}

export default CompleteHonestSign